import { isAcceptedRegion } from './locale-utilities';

const data = {
	ultimateViewing: {
		name: 'Ultimate Viewing',
		copy: 'Makes movies, boxsets and games look better than ever before.',
		flagColour: 'bg-water text-lightgreen',
		copyTextColour: 'text-primary',
		copyBackgroundColour: 'bg-lightblue',
	},
	moviesAndSport: {
		name: 'Movies & Sport',
		copy: 'See all the action come to life in amazing detail.',
		flagColour: 'bg-ice text-lightblue',
		copyTextColour: 'text-primary',
		copyBackgroundColour: 'bg-lightblue',
	},
	gaming: {
		name: 'Gaming',
		copy: 'Packed with tech to take your games to the next level.',
		flagColour: 'bg-toast text-burn',
		copyTextColour: 'text-primary',
		copyBackgroundColour: 'bg-bread',
	},
	family: {
		name: 'Family',
		copy: 'Loads of features to make family time extra special.',
		flagColour: 'bg-jam text-toast',
		copyTextColour: 'text-primary',
		copyBackgroundColour: 'bg-bread',
	},
};

const tradingRange = {
	QE65QN85AA: data.ultimateViewing,
	QE55QN85AA: data.ultimateViewing,
	QE65Q60AA: data.moviesAndSport,
	QE55Q60AA: data.moviesAndSport,
	UE65AU9000: data.gaming,
	UE55AU9000: data.gaming,
	UE70AU8000: data.family,
};

export const isProductInTradingRange = (sku) => {
	const keyFound = Object.keys(tradingRange).find((key) => sku === key);

	return keyFound && isAcceptedRegion(['AOL']) && tradingRange[keyFound];
};
